module.exports = __webpack_public_path__ + "static/media/calc.33f5add1.svg";